import { zodResolver } from '@hookform/resolvers/zod'
import {
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Stack,
    Typography
} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { AsyncSelect, Button, ControlledTextField } from 'src/components/forms'
import { EntityWithIdFields } from 'src/types'
import { z } from 'zod'
import { SectorComercialViewDTO, SectorComercialViewDTOFields } from './types'
import { HttpSectorComercialABM } from './api'
import { usePaisLogo } from 'src/hooks/usePaisLogo'

type EditSectorComercialFormProps = {
    sector: SectorComercialViewDTO
    onClose: () => void
}

const schema = z.object({
    [SectorComercialViewDTOFields.Nombre]: z.string().min(1, 'Requerido'),
    [SectorComercialViewDTOFields.CodPais]: z.number()
})

type FormData = z.infer<typeof schema>

function EditSectorComercialForm({ sector, onClose }: EditSectorComercialFormProps) {
    const { paisLogos } = usePaisLogo()

    const { control, handleSubmit } = useForm<FormData>({
        resolver: zodResolver(schema),
        defaultValues: {
            [SectorComercialViewDTOFields.Nombre]: sector[SectorComercialViewDTOFields.Nombre],
            [SectorComercialViewDTOFields.CodPais]: sector[SectorComercialViewDTOFields.CodPais]
        }
    })

    const onSubmitWrapper = () => {
        let mensajeError = 'No se pudo guardar'

        const promise = new Promise<void>((resolve, reject) => {
            handleSubmit(
                formData => {
                    HttpSectorComercialABM.update(sector[EntityWithIdFields.Id], formData)
                        .then(() => {
                            setTimeout(onClose, 500)
                            resolve()
                        })
                        .catch(reject)
                },
                () => {
                    mensajeError = 'Revise el formulario'
                    reject(mensajeError)
                }
            )()
        })

        toast.promise(promise, {
            success: 'Guardado',
            error: () => mensajeError,
            loading: 'Guardando'
        })

        return promise
    }

    return (
        <>
            <DialogTitle sx={{ pb: 0 }}>
                <Stack direction='row' spacing={1.5} alignItems='center'>
                    <EditIcon color='primary' />
                    <Typography variant='h6' fontWeight={600}>
                        Editar sector comercial
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent sx={{ pt: '24px !important', px: 5, pb: 4 }}>
                <Grid container spacing={4}>
                    <Grid item xs={12}>
                        <ControlledTextField
                            control={control}
                            name={SectorComercialViewDTOFields.Nombre}
                            label='Nombre'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <AsyncSelect
                            control={control}
                            name={SectorComercialViewDTOFields.CodPais}
                            label='País'
                            loadOptions={() => Promise.resolve(paisLogos)}
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button variant='text' color='inherit' onClick={onClose}>
                    Cancelar
                </Button>
                <Button variant='contained' color='primary' promise={onSubmitWrapper}>
                    Guardar
                </Button>
            </DialogActions>
        </>
    )
}

export default EditSectorComercialForm
